module.exports = __webpack_public_path__ + "static/media/Rapport_PCSN_redacted.ac7f36dc.pdf";